export enum VoiceDictationState {
	Initializing = 'Initializing',
	Uninitialized = 'Uninitialized',
	Unsupported = 'Unsupported',
	Recording = 'Recording',
	Stopped = 'Stopped',
	Error = 'Error',
}

export enum VoiceDictationStopReason {
	StoppedAccepted = 'STOPPED_ACCEPTED',
	StoppedRejected = 'STOPPED_REJECTED',
	TimeoutAccepted = 'TIMEOUT_ACCEPTED',
}

export type VoiceDictationResult =
	| {
			state: VoiceDictationState.Uninitialized;
			error?: string;
			transcription: null;
	  }
	| {
			state: VoiceDictationState.Initializing;
			error?: string;
			transcription: null;
	  }
	| {
			state: VoiceDictationState.Unsupported;
			error: string;
			transcription: null;
	  }
	| {
			state: VoiceDictationState.Recording;
			error?: string;
			transcription: string;
			chunkIndex: number;
	  }
	| {
			state: VoiceDictationState.Stopped;
			error?: string;
			transcription: string | null;
			stopReason: VoiceDictationStopReason;
	  }
	| {
			state: VoiceDictationState.Error;
			error: string;
			transcription: string | null;
	  };

export type WebSpeechToTextAPIAction =
	| { type: 'SET_INITIALIZING' }
	| { type: 'SET_RECORDING'; payload: { transcription: string; chunkIndex: number } }
	| { type: 'SET_STOPPED'; payload: { stopReason: VoiceDictationStopReason } }
	| { type: 'SET_ERROR'; payload: { error: string; transcription?: string | null } };

export type WebSpeechToTextTraceAction =
	| { type: 'TRANSCRIPTION_ITEM_CREATED'; payload: { createdItemChunkIndex: number } }
	| { type: 'START_WEBSOCKET_CONNECTION' }
	| { type: 'WEBSOCKET_CONNECTION_SUCCESS' }
	| { type: 'ERROR'; payload: { error: string } }
	| { type: 'STOP_RECORDING'; payload: { stopReason: VoiceDictationStopReason } };
